import { GapManagementDashboardService } from "@app/projects/network-assessment/gap-management-dashboard/gapManagementDashboardService";
import { GmdWidgetProps } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gmdWidgetProps";
import { MetricsDonut } from "@app/shared/metrics/MetricsDonut";
import { QESWidget, QESWidgetHeader, QESWidgetTitle, QESWidgetContent } from "@app/shared/widget";
import { useQuery } from "@tanstack/react-query";
import { FC, useMemo, useRef } from "react";

export const PriorityDistributionWidget: FC<GmdWidgetProps> = ({ errorBanner, loadingIcon }) => {
  const gapManagementDashboardService = useRef(new GapManagementDashboardService()).current;

  const { data: priorityDistributionData, isError, isLoading } = useQuery({
    enabled: true,
    queryFn: ({ signal }) => gapManagementDashboardService.getPriorityDistributionData(signal),
    queryKey: ["gmd-priority-distribution"],
  });

  const totalGaps = useMemo(() => {
    return priorityDistributionData?.segments.reduce((total, value) => total += value.numberValue, 0) || 0;
  }, [priorityDistributionData]);

  return (
    <QESWidget className="gap-management-dashboard__widget gap-management-dashboard__donut-chart-widget">
      <QESWidgetHeader>
        <QESWidgetTitle>Priority Distribution</QESWidgetTitle>
      </QESWidgetHeader>
      <QESWidgetContent>
        {isLoading ? loadingIcon :
          isError ? errorBanner : (
            <MetricsDonut
              {...priorityDistributionData}
              description={`A donut chart. Its segments represent ${priorityDistributionData?.segments.map((segment) => `${segment.numberValue} gaps ${segment.label}, `)}. The total is ${totalGaps}.`}
            />
          )}
      </QESWidgetContent>
    </QESWidget>
  )
}